// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ad4b99ca","431":"c15a5133","452":"703e6faa","453":"50be4ea6","609":"203f4f5f","670":"22924562","829":"d0649f63","887":"1a06026a","988":"a616ce69"}[chunkId] + ".chunk.js";
};